import {useCallback, useRef} from 'react'

// Stable function identity that always calls the latest closure — lets rows be
// memoized (React.memo) without risking stale state inside the handlers.
const useStableCallback = (fn) => {
    const fnRef = useRef(fn)
    fnRef.current = fn
    return useCallback((...args) => fnRef.current(...args), [])
}

export default useStableCallback
